function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M0,0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M758.8,54.2c2.1,40.4-120.3,79.7-273.4,87.7c-89.3,4.7-169.4-2.3-221-17c50.3,19.7,144.3,29.8,251.4,24.2 c158.1-8.3,284.5-47.8,282.4-88.2c-1-19.3-31.3-35.4-79.9-46c-2.2-0.5-3,2.8-0.9,3.6C742.9,28.3,758,40.4,758.8,54.2z"
}), React.createElement("path", {
  d: "M609.3,166.2l-3.9,22.7c-0.6,3.2-3.3,5.5-6.5,5.5h-77.1c-19.8,0-33.1-16-29.6-35.9l27-152.9c0.6-3.2,3.3-5.5,6.5-5.5h22.4 c4.1,0,7.2,3.7,6.5,7.8l-3.7,20.3c-0.7,4.1,2.4,7.8,6.5,7.8h27.9c4.8,0,8,5.1,6,9.4L585,68.3c-1.1,2.3-3.4,3.8-6,3.8h-30.2 c-3.2,0-6,2.3-6.5,5.5l-12.9,73.6c-0.8,4.1,1.9,7.3,6,7.3h67.5C606.9,158.5,610,162.2,609.3,166.2z"
}), React.createElement("path", {
  d: "M691.1,188.4c-0.6,3.5-3.6,6-7.1,6h-77.6c-19.8,0-33.1-16-29.6-35.9L592,72.1C595.5,52,614.3,36,634.1,36h60.6 c5.2,0,8.7,5.3,6.6,10.1L695,67.8c-1.1,2.6-3.7,4.4-6.6,4.4h-53.2c-4.1,0-7.9,3-8.7,7.1l-12.5,72c-0.8,4.1,1.9,7.3,6,7.3h67.8 c4.5,0,7.9,4,7.1,8.5L691.1,188.4z"
}), React.createElement("path", {
  d: "M581.6,35.9h-187c-29.7,0-41.6,13.1-45.1,33.2l-4.3,25c-3.5,19.8,12.5,39.1,32.3,39.1h64.9c4.1,0,6.5,3.3,6,7.1l-1.9,10.9 c-0.8,4.1-4.3,7.3-8.4,7.3H289.6v35.9h149.3c20.1,0,38.9-16,42.4-35.9l4.3-25.3c3.5-19.8-9.5-36.1-29.6-36.1h-64.7 c-4.1,0-6.8-3.3-6.2-7.1l1.9-10.9c0.8-4.1,4.6-7.1,8.7-7.1h178.6c2.1,0,4.1-1.2,5-3.2l7.3-25C588.3,40.2,585.7,35.9,581.6,35.9z"
}));

var SvgStcLogo = function SvgStcLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1062.6 194.4",
    style: {
      enableBackground: "new 0 0 1062.6 194.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStcLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stc_logo.ec89bca4.svg";
export { ForwardRef as ReactComponent };